import { render, staticRenderFns } from "./AlternativeDashboard.vue?vue&type=template&id=6adb6e2d&"
import script from "./AlternativeDashboard.vue?vue&type=script&lang=js&"
export * from "./AlternativeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeDashboard.vue?vue&type=style&index=0&id=6adb6e2d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports